import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../public/locales/en/translation.json';
import ru from '../public/locales/ru/translation.json';
import de from '../public/locales/de/translation.json';
import zh from '../public/locales/zh/translation.json';
import ko from '../public/locales/ko/translation.json';

const resources = {
  en: { translation: en },
  ru: { translation: ru },
  de: { translation: de },
  zh: { translation: zh },
  ko: { translation: ko },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
